import { Link } from 'react-router-dom';
import { useAuth, UserButton, SignInButton, AUTH_ENABLED } from '../../lib/auth';
import type { ReactNode } from 'react';

function AuthSection() {
  if (!AUTH_ENABLED) return null;

  const { isSignedIn } = useAuth();

  if (isSignedIn) {
    return (
      <>
        <Link to="/dashboard">Dashboard</Link>
        <UserButton />
      </>
    );
  }

  return (
    <SignInButton>
      <button
        className="btn btn-sm"
        style={{
          background: 'rgba(255,255,255,0.2)',
          color: 'white',
          border: '1px solid rgba(255,255,255,0.3)',
        }}
      >
        Sign In
      </button>
    </SignInButton>
  );
}

export function AppLayout({ children }: { children: ReactNode }) {
  return (
    <>
      <header className="app-header">
        <Link to="/" style={{ color: 'white', textDecoration: 'none' }}>
          <h1>
            <span className="header-title-full">MN Mortgage Calculator</span>
            <span className="header-title-short">Threshold</span>
          </h1>
        </Link>
        <div className="app-header-right">
          <Link to="/">Calculator</Link>
          <AuthSection />
        </div>
      </header>
      <main>{children}</main>
      <footer>
        For estimation purposes only. Consult a licensed mortgage professional for actual rates and terms.<br />
        Minnesota property tax and program information may change. Verify at mnhousing.gov.
      </footer>
    </>
  );
}
